import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    line-height: 1.6;
    font-family: ${({ theme }) => theme.fontFamily.regular};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  /* Form controls reset to the browser font by default; inherit the themed one. */
  button,
  input,
  textarea,
  select {
    font-family: inherit;
  }

  #root {
    min-height: 100vh;
  }
`;

export default GlobalStyles;
